(() => {
  if (customElements.get('bbq-hero-carousel')) return;
  class BBQHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.slides = [...this.querySelectorAll('.bhc__slide')];
      this.tabs = [...this.querySelectorAll('[data-slide]')];
      this.index = 0; this.userPaused = false; this.hovered = false; this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal: this.abort.signal });
      on(this, 'click', (event) => {
        const button = event.target.closest('button'); if (!button) return;
        if (button.matches('[data-slide]')) this.show(Number(button.dataset.slide), true);
        else if (button.matches('[data-prev]')) this.show(this.index - 1, true);
        else if (button.matches('[data-next]')) this.show(this.index + 1, true);
        else if (button.matches('.bhc__pause')) {
          this.userPaused = !this.userPaused;
          button.setAttribute('aria-pressed', String(this.userPaused));
          button.setAttribute('aria-label', this.userPaused ? 'Start slide rotation' : 'Pause slide rotation');
          button.textContent = this.userPaused ? '▷' : 'Ⅱ'; this.schedule();
        }
      });
      on(this, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        event.preventDefault();
        this.show(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        this.tabs[this.index]?.focus();
      });
      on(this, 'pointerdown', e => { this.start = e.isPrimary ? { x: e.clientX, y: e.clientY, type: e.pointerType } : null; }, { passive: true });
      on(this, 'pointerup', e => {
        if (!this.start || this.start.type === 'mouse') return;
        const dx = e.clientX - this.start.x, dy = e.clientY - this.start.y; this.start = null;
        if (Math.abs(dx) > 55 && Math.abs(dy) < 45) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      on(this, 'pointercancel', () => { this.start = null; });
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => this.schedule());
      on(document, 'shopify:block:select', e => {
        const slide = e.target.closest('.bhc__slide');
        if (slide && this.contains(slide)) { this.userPaused = true; this.show(this.slides.indexOf(slide), false); }
      });
      this.show(0, false);
      this.preloadTimer = setTimeout(() => this.slides.slice(1).forEach(s => this.load(s)), 1200);
    }
    load(slide) {
      slide?.querySelectorAll('[data-srcset]').forEach(el => { el.srcset = el.dataset.srcset; delete el.dataset.srcset; });
      slide?.querySelectorAll('img[data-src]').forEach(el => { el.src = el.dataset.src; delete el.dataset.src; });
    }
    show(index, manual) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.load(this.slides[this.index]);
      this.slides.forEach((slide, i) => {
        const active = i === this.index; slide.classList.toggle('is-active', active);
        slide.inert = !active; slide.setAttribute('aria-hidden', String(!active));
      });
      this.tabs.forEach((tab, i) => { if (i === this.index) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current'); });
      if (manual) {
        const status = this.querySelector('.bhc__status');
        if (status) status.textContent = this.slides[this.index].getAttribute('aria-label');
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.motion?.matches || this.userPaused || this.hovered || this.focused || document.hidden || !this.isConnected) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), Math.max(6000, Number(this.dataset.interval) || 8000));
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.timer); clearTimeout(this.preloadTimer); }
  }
  customElements.define('bbq-hero-carousel', BBQHeroCarousel);
})();
